import { useState, useEffect } from "react";
import { Popover, Button, Badge } from "antd";
import { useMercuryContext } from "../../context";
import { Progress } from "shared/components/Components";

const ProgressLoader = () => {

    const { progress } = useMercuryContext();
    const [open, setOpen] = useState(false);
    const [show, setShow] = useState(true);
    const bars: any = progress ? Array.from(progress.values()) : null;
    const completed = bars?.filter((bar: any) => bar.item.progress !== 1);
    const latestCompletedIndex = bars?.length ? bars.length - 1 : -1;
    const visibleBars = bars?.filter((bar: any, index: number) => {
        const isComplete = bar.item.progress === 1;
        return !isComplete || (completed?.length === 0 && index === latestCompletedIndex);
    });

    const total = completed?.reduce((accumulator: any, currentValue: any) => {
        const p = Number(currentValue.item.progress) || 0;
        return accumulator + Math.max(0, Math.min(1, p));
    }, 0)

    useEffect(() => {

        if (((total * 100) / completed?.length) === 100 || completed?.length ===0 ) {
            setTimeout(function () {
                setShow(false)
            }, 8000);
        } else {
            setShow(true)
        }

    }, [show, total]);

    if (!progress) {
        return null;
    }

    const handlePopoverVisibleChange = () => {
        setOpen((prev) => !prev);
    };

    const content = visibleBars?.map((bar: any) => {
        const totalRows = Math.max(0, Number(bar.item.total) || 0);
        const safeProgress = Math.max(0, Math.min(1, Number(bar.item.progress) || 0));
        const isComplete = safeProgress === 1;
        const errorIds = Array.isArray(bar.item.errors)
            ? Array.from(new Set(bar.item.errors.map((p: any) => (p && typeof p === "object" ? p.id : null)).filter(Boolean)))
            : [];
        const uniqueErrorMessages = Array.isArray(bar.item.errors)
            ? Array.from(new Set(bar.item.errors.map((p: any) => (typeof p === "string" ? p : (p?.message || p?.error || "")).toString().trim()).filter(Boolean)))
            : [];
        const errorsCount = Math.min(totalRows, errorIds.length > 0 ? errorIds.length : uniqueErrorMessages.length);
        const successCount = Math.max(0, totalRows - errorsCount);

        return (
            <>
        <span key={bar.requestId}>
          <div
              className="show-bar"
          >
            <span className={"progress-title"}>
                            {isComplete
                  ? `${successCount} of ${
                      totalRows
                  } successful`
                  : bar.item.name}
            </span>
                            {errorsCount > 0 && isComplete ? (
                  <div style={{ color: "var(--red)", maxWidth: "260px" }}>
                      {`${errorsCount} of ${totalRows} failed`}
                      {/*<br />*/}
                      {/*<div style={{ overflowWrap: "break-word" }}>*/}
                      {/*    {errorIds && `id(s) : ${errorIds?.join(", ")} `}*/}
                      {/*</div>*/}
                  </div>
              ) : (
                  ""
              )}
              <Progress
                  status={"active"}
                  progress={Math.ceil(safeProgress * 100)}
                  showInfo={true}
                  strokeColor={{ "0%": "#C4FFFC", "100%": "var(--primary-color)" }}
                  trailColor="#eee"
                  type={"line"}
                  size={"small"}
              />
          </div>
        </span>
            </>
        );
    });

    return (
        <>
            {show &&
                <Popover
                    placement="bottomLeft"
                    content={content}
                    trigger="click"
                    open={open}
                >
                    <Button onClick={handlePopoverVisibleChange} type="link" style={{ all: 'unset', height: '100%' }}>
                        <Badge
                            count={completed?.length}
                            style={{ backgroundColor: "var(--tertiary-color)", top: "3px", right: "2px" }}
                            size="small"
                        >
                            <Progress
                                status={"active"}
                                progress={completed?.length !==0 ? (total * 100) / completed?.length : 100}
                                type={"circle"}
                                size="small"
                                strokeColor={{
                                    "0%": "#C4FFFC",
                                    "100%": "var(--primary-color)",
                                }}
                                trailColor="#eee"
                            />
                        </Badge>
                    </Button>
                </Popover>}
        </>
    );
};

export default ProgressLoader;